import { render } from "./Add_Envoi_Postal_Form.vue?vue&type=template&id=25c284e5"
import script from "./Add_Envoi_Postal_Form.vue?vue&type=script&lang=js"
export * from "./Add_Envoi_Postal_Form.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__